import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSInput } from '../input/index.esm.js';
import '../faux-input/index.esm.js';
import '../password-input/index.esm.js';
import '../informative-input/index.esm.js';
import '../textarea/index.esm.js';
import '../chat-textarea/index.esm.js';
import '../fake-input/index.esm.js';
import '../card-number-input/index.esm.js';
import '../select/index.esm.js';
import '../swapper-input/index.esm.js';
class EGDSTextInput extends React.Component {
  static displayName = 'EGDSTextInput';
  render() {
    return jsx(EGDSInput, {
      ...this.props,
      type: "text"
    });
  }
}
export { EGDSTextInput };